import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pm" }
const _hoisted_2 = { class: "pm-head-text" }
const _hoisted_3 = { class: "pm-sub" }
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 0,
  class: "ph ph-caret-down pm-caret",
  "aria-hidden": "true"
}
const _hoisted_6 = {
  key: 0,
  class: "pm-tools"
}
const _hoisted_7 = { class: "pm-search" }
const _hoisted_8 = {
  class: "pm-seg",
  role: "group",
  "aria-label": "Afficher"
}
const _hoisted_9 = ["aria-pressed", "onClick"]
const _hoisted_10 = { class: "pm-bulk" }
const _hoisted_11 = {
  key: 0,
  class: "pm-empty"
}
const _hoisted_12 = {
  key: 1,
  class: "pm-grid"
}
const _hoisted_13 = { class: "pm-card-head" }
const _hoisted_14 = {
  class: "pm-avatar",
  "aria-hidden": "true"
}
const _hoisted_15 = { class: "pm-card-title" }
const _hoisted_16 = ["title"]
const _hoisted_17 = ["checked", "aria-label", "onChange"]
const _hoisted_18 = {
  key: 0,
  class: "pm-card-body"
}
const _hoisted_19 = { class: "pm-actions-head" }
const _hoisted_20 = { class: "pm-links" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "pm-chips" }
const _hoisted_24 = ["checked", "onChange"]
const _hoisted_25 = {
  key: 0,
  class: "pm-hint"
}
const _hoisted_26 = {
  key: 1,
  class: "pm-pending",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", {
      class: _normalizeClass(["pm-head", { 'is-open': _ctx.open, 'is-static': !_ctx.collapsible }])
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.collapsible ? 'button' : 'div'), {
        type: _ctx.collapsible ? 'button' : undefined,
        class: "pm-toggle",
        "aria-expanded": _ctx.collapsible ? _ctx.open : undefined,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.collapsible && (_ctx.open = !_ctx.open)))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "pm-eyebrow" }, "Sécurité", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "pm-title" }, "Permissions d'utilisateur", -1)),
            _createElementVNode("p", _hoisted_3, [
              _createElementVNode("b", null, _toDisplayString(_ctx.permStats.granted), 1),
              _createTextVNode(" / " + _toDisplayString(_ctx.permStats.total) + " permissions accordées · " + _toDisplayString(_ctx.permStats.modules) + " module(s) accessibles ", 1)
            ]),
            _createElementVNode("div", {
              class: "pm-meter",
              title: `${_ctx.permStats.percent}% des permissions accordées`
            }, [
              _createElementVNode("span", {
                style: _normalizeStyle({ width: _ctx.permStats.percent + '%' })
              }, null, 4)
            ], 8, _hoisted_4)
          ]),
          (_ctx.collapsible)
            ? (_openBlock(), _createElementBlock("i", _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["type", "aria-expanded"])),
      (_ctx.open)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("i", {
                class: "ph ph-magnifying-glass",
                "aria-hidden": "true"
              }, null, -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.permSearch) = $event)),
                type: "search",
                placeholder: "Rechercher une permission…",
                "aria-label": "Rechercher une permission"
              }, null, 512), [
                [_vModelText, _ctx.permSearch]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permViewOptions, (opt) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: opt.value,
                  type: "button",
                  class: _normalizeClass({ active: _ctx.permView === opt.value }),
                  "aria-pressed": _ctx.permView === opt.value,
                  onClick: ($event: any) => (_ctx.permView = opt.value)
                }, _toDisplayString(opt.label), 11, _hoisted_9))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-success",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setAllPermissions(true)))
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("i", {
                  class: "ph ph-check-square",
                  "aria-hidden": "true"
                }, null, -1),
                _createTextVNode(" Tout accorder ", -1)
              ])),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-danger",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setAllPermissions(false)))
              }, _cache[8] || (_cache[8] = [
                _createElementVNode("i", {
                  class: "ph ph-square",
                  "aria-hidden": "true"
                }, null, -1),
                _createTextVNode(" Tout retirer ", -1)
              ]))
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.visibleGroups.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[9] || (_cache[9] = [
                _createElementVNode("i", {
                  class: "ph ph-magnifying-glass",
                  "aria-hidden": "true"
                }, null, -1),
                _createElementVNode("p", null, "Aucune permission ne correspond à votre recherche.", -1)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleGroups, (group) => {
                  return (_openBlock(), _createElementBlock("article", {
                    key: group.key,
                    class: _normalizeClass(["pm-card", { 'is-on': group.check }])
                  }, [
                    _createElementVNode("header", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, [
                        _createElementVNode("i", {
                          class: _normalizeClass(group.check ? 'ph ph-lock-key-open' : 'ph ph-lock-key')
                        }, null, 2)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("strong", null, _toDisplayString(group.name), 1),
                        _createElementVNode("small", null, _toDisplayString(group.check ? "Accès au module accordé" : "Aucun accès au module"), 1)
                      ]),
                      _createElementVNode("label", {
                        class: "pm-switch",
                        title: group.check ? 'Retirer l\'accès' : 'Accorder l\'accès'
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: group.check,
                          "aria-label": `Accès au module ${group.name}`,
                          onChange: ($event: any) => (_ctx.setParent(group, $event.target.checked))
                        }, null, 40, _hoisted_17),
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "pm-switch-track" }, [
                          _createElementVNode("span", { class: "pm-switch-thumb" })
                        ], -1))
                      ], 8, _hoisted_16)
                    ]),
                    (group.permissions && group.permissions.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("span", null, [
                              _cache[11] || (_cache[11] = _createTextVNode("Actions ", -1)),
                              _createElementVNode("b", null, _toDisplayString(group.enabled.length) + "/" + _toDisplayString(group.permissions.length), 1)
                            ]),
                            _createElementVNode("span", _hoisted_20, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => (_ctx.setAllInGroup(group, true))
                              }, "Toutes", 8, _hoisted_21),
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => (_ctx.setAllInGroup(group, false))
                              }, "Aucune", 8, _hoisted_22)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredChildren(group), (perm) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: perm.key,
                                class: _normalizeClass(["pm-chip", { 'is-on': perm.check, 'is-changed': _ctx.changed(perm.key, perm.check) }])
                              }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: perm.check,
                                  onChange: ($event: any) => (_ctx.setChild(group, perm, $event.target.checked))
                                }, null, 40, _hoisted_24),
                                _createElementVNode("i", {
                                  class: _normalizeClass(perm.check ? 'ph ph-check-circle' : 'ph ph-circle'),
                                  "aria-hidden": "true"
                                }, null, 2),
                                _createElementVNode("span", null, _toDisplayString(perm.name), 1)
                              ], 2))
                            }), 128))
                          ]),
                          (!group.check)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_25, _cache[12] || (_cache[12] = [
                                _createElementVNode("i", {
                                  class: "ph ph-info",
                                  "aria-hidden": "true"
                                }, null, -1),
                                _createTextVNode(" Cocher une action accorde aussi l'accès au module. ", -1)
                              ])))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ]))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.showPending && _ctx.changes > 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
          _cache[13] || (_cache[13] = _createElementVNode("i", {
            class: "ph ph-warning",
            "aria-hidden": "true"
          }, null, -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.changes), 1),
          _createTextVNode(" modification" + _toDisplayString(_ctx.changes > 1 ? "s" : "") + " de permissions non enregistrée" + _toDisplayString(_ctx.changes > 1 ? "s" : ""), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}